module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = (resourceData || {}).data || {};\n%>\n<div class=\"container-fluid text-simple\">\n<div class=\"row\">\n<div class=\"col\">\n<div class=\"container\">\n<div class=\"row\">\n<div class=\"col-md-12\">\n<h1>Termine &amp; Anmeldung</h1>\n<%- model.intro %>\n<%\nif (Object.keys(data).length > 0) {\n%>\n<div class=\"table-responsive\">\n<table class=\"table table-hover\">\n<thead>\n<tr>\n<td><strong>Datum</strong></td>\n<td><strong>Tag</strong></td>\n<td><strong>Zeit</strong></td>\n<td><strong>Veranstaltung</strong></td>\n<td><strong>Start</strong></td>\n<!--                                    <td><strong>Anmeldung ab</strong></td>-->\n<td align=\"right\">&nbsp;</td>\n</tr>\n</thead>\n<tbody>\n<%\nlet html = '';\nfor (let i in data) {\nlet event = data[i].attributes.event;\nlet eventParts = data[i].attributes.eventParts['de-at'];\nlet startDate = utils.moment(event.startTS);\nlet buttonDetailText = 'Details';\nlet registerStartDate = '-';\nif (event.registrationStartTS || event.registrationEndTS) {\n// if (event.registrationStartTS) {\n//     registerStartDate = utils.moment(event.registrationStartTS).format('D. MMMM YYYY');\n//     buttonDetailText = 'Details &amp; Anmeldung';\n// }\nif (event.registrationEndTS && utils.moment(event.registrationEndTS).isAfter(utils.moment(),'day')) {\nbuttonDetailText = 'Details &amp; Anmeldung';\n}\n}\nlet linkPath = '';\n// let hideDetailPage = !!((eventParts.additionalInformation || {}).hideEventDetailPage || 0);\nif (eventParts.path && !(!event.registrationStartTS && !event.registrationEndTS)) {\nlinkPath = eventParts.path;\n}\nlet startTime = startDate.format('HH:mm');\nif (startTime === '00:00') startTime = '-';\nelse startTime += ' Uhr';\nhtml+= `\n<tr${linkPath ? ` class=\"clickable\" onclick=\"window.location='${linkPath}'\"` : ''}>\n<td>${startDate.format('D. MMMM YYYY')}</td>\n<td>${startDate.format('dddd')}</td>\n<td>${startTime}</td>\n<td>${eventParts.title}</td>\n<td>${eventParts.subTitle || '-'}</td>\n<!--         <td>${registerStartDate}</td> -->\n<td align=\"right\">${linkPath ? `<a href=\"${linkPath}\" class=\"table-button\">${buttonDetailText}</a>` : '&nbsp;'}</td>\n</tr>\n`;\n// console.log(event)\n// console.log(eventParts)\n}\n%>                              <%- html %>\n</tbody>\n</table>\n</div>\n<%                      } else {\n%>                        <br><br><p>Zur Zeit stehen noch keine Termine für Veranstaltungen fest.</p>\n<%                      }\n%>                  </div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  , __filename = "components\\templates\\events\\list.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = (resourceData || {}).data || {};

    ; __line = 3
    ; __append("\n<div class=\"container-fluid text-simple\">\n<div class=\"row\">\n<div class=\"col\">\n<div class=\"container\">\n<div class=\"row\">\n<div class=\"col-md-12\">\n<h1>Termine &amp; Anmeldung</h1>\n")
    ; __line = 11
    ; __append( model.intro )
    ; __append("\n")
    ; __line = 12
    ; 
if (Object.keys(data).length > 0) {

    ; __line = 14
    ; __append("\n<div class=\"table-responsive\">\n<table class=\"table table-hover\">\n<thead>\n<tr>\n<td><strong>Datum</strong></td>\n<td><strong>Tag</strong></td>\n<td><strong>Zeit</strong></td>\n<td><strong>Veranstaltung</strong></td>\n<td><strong>Start</strong></td>\n<!--                                    <td><strong>Anmeldung ab</strong></td>-->\n<td align=\"right\">&nbsp;</td>\n</tr>\n</thead>\n<tbody>\n")
    ; __line = 29
    ; 
let html = '';
for (let i in data) {
let event = data[i].attributes.event;
let eventParts = data[i].attributes.eventParts['de-at'];
let startDate = utils.moment(event.startTS);
let buttonDetailText = 'Details';
let registerStartDate = '-';
if (event.registrationStartTS || event.registrationEndTS) {
// if (event.registrationStartTS) {
//     registerStartDate = utils.moment(event.registrationStartTS).format('D. MMMM YYYY');
//     buttonDetailText = 'Details &amp; Anmeldung';
// }
if (event.registrationEndTS && utils.moment(event.registrationEndTS).isAfter(utils.moment(),'day')) {
buttonDetailText = 'Details &amp; Anmeldung';
}
}
let linkPath = '';
// let hideDetailPage = !!((eventParts.additionalInformation || {}).hideEventDetailPage || 0);
if (eventParts.path && !(!event.registrationStartTS && !event.registrationEndTS)) {
linkPath = eventParts.path;
}
let startTime = startDate.format('HH:mm');
if (startTime === '00:00') startTime = '-';
else startTime += ' Uhr';
html+= `
<tr${linkPath ? ` class="clickable" onclick="window.location='${linkPath}'"` : ''}>
<td>${startDate.format('D. MMMM YYYY')}</td>
<td>${startDate.format('dddd')}</td>
<td>${startTime}</td>
<td>${eventParts.title}</td>
<td>${eventParts.subTitle || '-'}</td>
<!--         <td>${registerStartDate}</td> -->
<td align="right">${linkPath ? `<a href="${linkPath}" class="table-button">${buttonDetailText}</a>` : '&nbsp;'}</td>
</tr>
`;
// console.log(event)
// console.log(eventParts)
}

    ; __line = 68
    ; __append("                              ")
    ; __append( html )
    ; __append("\n</tbody>\n</table>\n</div>\n")
    ; __line = 72
    ;                       } else {

    ; __line = 73
    ; __append("                        <br><br><p>Zur Zeit stehen noch keine Termine für Veranstaltungen fest.</p>\n")
    ; __line = 74
    ;                       }

    ; __line = 75
    ; __append("                  </div>\n</div>\n</div>\n</div>\n</div>\n</div>")
    ; __line = 80
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components\templates\events\list.ejs

}